import CustomFieldsV1 from "../../gd/const/fields/custom-fields-v1";
import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import {CustomFieldAccess, CustomFieldParams, CustomFieldScope, CustomFieldV1Type} from "./@const";
import Field1ToField2Converter from "../../fields3/fields-converter-1-2";


export default class SessionCustomField extends ModelEntity {


    public companyId        : ID = gd.companyId// do we need it ?

    public name             : string
    public type             : CustomFieldV1Type

    public access           : CustomFieldAccess

    public isDeleted        : boolean = false

    // public sortPosition     : number
    public isInherited      : boolean   = false

    public params           : CustomFieldParams



    constructor(data:any) {
        super(data['id'], EntityType.CUSTOM_FIELD)

        this.type             = _.get(data,'type')
        this.name             = _.get(data,'name')


        this.sortPosition       = _.get(data,'sortPosition', 0)
        this.isDeleted          = _.get(data,'isDeleted', false)
        this.access             = _.get(data,'access', CustomFieldAccess.EVERYONE)


        this.params             = this.normalizeParams(data.params)



        // public isDeleted: {
        //         type: 'boolean',
        //     default: false
        //     },
        // public isInherited      : boolean   = false - default flase
    }

    get isTaskField():boolean {
        return this.checkScope(CustomFieldScope.TASK)
    }

    checkScope(scope:CustomFieldScope):boolean {
        return this.params.scope.includes(scope)
    }

    get displayName() {
        return this.params.displayName || this.name
    }

    get defaultValue():any {

        let res = null;

        switch (this.type) {
            case CustomFieldV1Type.STRING:         res = "";       break;
            case CustomFieldV1Type.BOOLEAN:        res = false;    break;
            case CustomFieldV1Type.NUMBER:         res = null;     break;
            case CustomFieldV1Type.CURRENCY:       res = null;     break;
            case CustomFieldV1Type.PERCENTAGE:     res = null;     break;
            case CustomFieldV1Type.DATE:           res = null;     break;
            case CustomFieldV1Type.LIST:           res = null;     break;
            case CustomFieldV1Type.LIST_MULTI:     res = [];       break;
            case CustomFieldV1Type.RATING:         res = null;     break;
            case CustomFieldV1Type.EMAIL:          res = null;     break;
            case CustomFieldV1Type.PHONE:          res = null;     break;
            case CustomFieldV1Type.URL:            res = null;     break;
            case CustomFieldV1Type.USER:           res = null;     break;
            case CustomFieldV1Type.USERS:          res = null;     break;
            case CustomFieldV1Type.RAG:            res = null;     break;
            case CustomFieldV1Type.FORMULA:        res = "";       break;
        }

        return res;
    }

    get valueType():any {

        let res = null;

        switch (this.type) {
            case CustomFieldV1Type.STRING:         res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.BOOLEAN:        res = gd.const.fields.valueType.BOOLEAN;      break;
            case CustomFieldV1Type.NUMBER:         res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.CURRENCY:       res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.PERCENTAGE:     res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.DATE:           res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.LIST:           res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.LIST_MULTI:     res = gd.const.fields.valueType.JSON;         break;
            case CustomFieldV1Type.RATING:         res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.EMAIL:          res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.PHONE:          res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.URL:            res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.USER:           res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.USERS:          res = gd.const.fields.valueType.JSON;         break;
            case CustomFieldV1Type.TEXT:           res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.RAG:            res = gd.const.fields.valueType.FLOAT;        break;
            case CustomFieldV1Type.FORMULA:        res = gd.const.fields.valueType.STRING;       break;
            case CustomFieldV1Type.COLOR:          res = gd.const.fields.valueType.FLOAT;        break;

            case CustomFieldsV1.type.REACTION:
            case CustomFieldsV1.type.VOTING:
            case CustomFieldsV1.type.ADDRESS:
            case CustomFieldsV1.type.ATTACHMENT:
            case CustomFieldsV1.type.INTERNAL_DB:
            case CustomFieldsV1.type.DEPARTMENT:
            case CustomFieldsV1.type.SKILLS:
                return gd.const.fields.valueType.JSON;

            case CustomFieldsV1.type.TIME_OF_DAY:  return gd.const.fields.valueType.JSON; // Tut Moment?!
            case CustomFieldsV1.type.DATE_AND_TIME:  return gd.const.fields.valueType.JSON; // Tut Moment?!
            case CustomFieldsV1.type.TOGGLE:  return gd.const.fields.valueType.BOOLEAN;

            default:
                console.error("#Error #kdji213 no custom field type found")
        }

        return res;
    }

    get typeName():string {

        switch (this.type) {

            case CustomFieldV1Type.STRING:
                return "string"
            case CustomFieldV1Type.BOOLEAN:        return "boolean";
            case CustomFieldV1Type.NUMBER:         return "number";
            case CustomFieldV1Type.CURRENCY:       return "currency";
            case CustomFieldV1Type.PERCENTAGE:     return "percentage";
            case CustomFieldV1Type.DATE:           return "date";
            case CustomFieldV1Type.LIST:           return "list";
            case CustomFieldV1Type.INTERNAL_DB:    return "list";
            case CustomFieldV1Type.LIST_MULTI:     return "list";
            case CustomFieldV1Type.RATING:         return "rating";
            case CustomFieldV1Type.EMAIL:          return "email";
            case CustomFieldV1Type.PHONE:          return "phone";
            case CustomFieldV1Type.URL:            return "url";
            case CustomFieldV1Type.USER:           return "user";
            case CustomFieldV1Type.USERS:          return "users";
            case CustomFieldV1Type.TEXT:           return "text";
            case CustomFieldV1Type.RAG:            return "number";
            case CustomFieldV1Type.COLOR:          return "number";
            default:
                return 'unknown'
        }


    }

    convertToField3() {
        return Field1ToField2Converter.convert(this.id)
    }

    get icon():string {
        const cf = gd.const.customFields[this.type];
        return cf ? cf.icon : '';
    }

    get listColumnWidth():number {
        let defaultWidth = 100;

        switch(this.type) {

            case CustomFieldV1Type.CURRENCY:
            case CustomFieldV1Type.DATE:
            case CustomFieldV1Type.LIST:
            case CustomFieldV1Type.INTERNAL_DB:
                defaultWidth = 100;
                break;

            case CustomFieldV1Type.EMAIL:
                defaultWidth = 180;
                break;

            case CustomFieldV1Type.DEPARTMENT:
            case CustomFieldV1Type.SKILLS:
            case CustomFieldV1Type.LIST_MULTI:
            case CustomFieldV1Type.TEXT:
                defaultWidth = 200;
                break;

            case CustomFieldV1Type.STRING:
            case CustomFieldV1Type.PHONE:
            case CustomFieldV1Type.URL:
            case CustomFieldV1Type.USER:
            case CustomFieldV1Type.USERS:
                defaultWidth = 160;
                break;
            case CustomFieldV1Type.BOOLEAN:
            case CustomFieldV1Type.NUMBER:
            case CustomFieldV1Type.PERCENTAGE:
            case CustomFieldV1Type.RAG:
            case CustomFieldV1Type.COLOR:
                defaultWidth = 90;
                break;

            case CustomFieldV1Type.RATING:
                defaultWidth = 136;
                break;

            case CustomFieldsV1.type.ADDRESS:
                defaultWidth = 200;
                break

            case CustomFieldsV1.type.ATTACHMENT:
                defaultWidth = 200;
                break;
        }
        const titleWidth = this.getTitleWidth();

        if (titleWidth + 30 > defaultWidth) {
            defaultWidth = titleWidth + 30;
        }

        return defaultWidth;
    }


    getTitleWidth() {

        const symbols = this.name.length;

        if (symbols<=6) return 50;
        if (symbols<=10) return 75;
        if (symbols<=15) return 110;
        return 120;
    }

    clone() {
        return new SessionCustomField(this.toJSON())
    }

    setInherited(value:boolean) {
        this.isInherited = value;
    }

    // it is used !!!
    updatePayload(value:any) {
        return {
            value       : value,
            type        : this.valueType
        }
    }

    private normalizeParams(data:any):any {

        const result = _.assign({},data);
        result.scope = _.get(data, 'scope', [CustomFieldScope.TASK])

        return result
    }

    toJSON():JSONObject {
        return {
            id              : this.id,
            name            : this.name,
            type            : this.type,
            access          : this.access,
            isDeleted       : this.isDeleted,
            sortPosition    : this.sortPosition,
            isInherited     : this.isInherited,
            params          : this.params,
        };
    }



}


